// GSAP version of TopScene's CSS beats (same order and timing). Gets gsap and the <svg>, returns the timeline.
export default function timeline(gsap, root) {
  const q = (n) => root.querySelector(`[data-anim="${n}"]`);
  return gsap.timeline({ defaults: { ease: 'power2.out' } })
    .from(root.querySelectorAll('.trail'), { strokeDashoffset: 60, duration: 2.6 }, 0)
    .to(q('phone'), { rotation: -4, y: 4, svgOrigin: '420 260', duration: 0.3, yoyo: true, repeat: 1 }, 0.2)
    .to(q('shutter'), { rotation: 60, scale: 0.8, transformOrigin: '50% 50%', duration: 0.25, yoyo: true, repeat: 1 }, 0.55)
    .fromTo(q('flash'), { opacity: 0 }, { opacity: 0.85, duration: 0.12, yoyo: true, repeat: 1 }, 0.75)
    .from(q('photo'), { opacity: 0, x: 30, y: -110, rotation: -14, scale: 0.55, svgOrigin: '366 418', duration: 0.9, ease: 'expo.out' }, 0.95)
    .from(q('note'), { opacity: 0, x: -40, duration: 0.7, ease: 'expo.out' }, 1.6)
    .from(q('pin'), { opacity: 0, scale: 0.2, transformOrigin: '50% 100%', duration: 0.6, ease: 'back.out(3)' }, 2.1);
}
